(function () {
  'use strict';

  var lastEventKey = null;
  var timer = null;

  function trackSearch() {
    var marker = document.querySelector('#facets-filterable [data-mf-search-event]');
    if (!marker) {
      lastEventKey = null;
      return;
    }

    var query = (marker.getAttribute('data-mf-search-terms') || '').trim().slice(0, 100);
    var count = Number(marker.getAttribute('data-mf-search-count'));
    if (!query || !Number.isFinite(count) || /@|\d{7,}/.test(query)) return;

    var key = location.pathname + location.search + ':' + count + ':' + query;
    if (key === lastEventKey) return;
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;

    lastEventKey = key;
    var data = {
      query: query,
      result_count: count,
      locale: marker.getAttribute('data-mf-search-locale') || document.documentElement.lang,
      filtered: /(?:^|&)(?:filter\.|sort_by=)/.test(location.search.slice(1))
    };

    try {
      Promise.resolve(Shopify.analytics.publish('music_forecast:search_results', data)).catch(function () {});
      if (count === 0) {
        Promise.resolve(Shopify.analytics.publish('music_forecast:zero_results', data)).catch(function () {});
      }
    } catch (e) {
      lastEventKey = null;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(trackSearch, 120);
  }

  function init() {
    trackSearch();
    var root = document.getElementById('MainContent') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    document.addEventListener('mf:softnav', schedule);
    window.addEventListener('popstate', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
